export default {"src":"/_next/static/media/slide-scalable-icon.809db201.svg","height":77,"width":71};